import { maskCurrency, maskCurrencyFromStored } from '@/shared/lib/input-masks';
import { onlyDigits } from '@/shared/lib/format';

/** Parseia máscara pt-BR (1.234,56) → number. Sempre unidade monetária da API (real). */
export function parseMaskedMoney(raw: string): number {
  if (!raw.trim()) return 0;
  const cleaned = raw.replace(/[R$€\s]/gi, '').replace(/\./g, '').replace(',', '.');
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : 0;
}

export function formatMaskedMoney(n: number): string {
  if (!Number.isFinite(n) || n <= 0) return '';
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Aplica máscara a partir de número (ex.: valor vindo do QR NFC-e). */
export function moneyFromNumber(n: number): string {
  if (!Number.isFinite(n) || n <= 0) return '';
  const cents = Math.round(n * 100);
  return maskCurrencyFromStored(String(cents)) || maskCurrency(onlyDigits(String(cents)));
}
